import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";

import ControlRow from "../utils/components/ControlRow";
import TariffModal from "./modals/TariffModal";
import ConfirmationModal from "../utils/components/ConfirmationModal";

import { setAlert } from "../../actions/alertActions";
import { searchModule } from "../utils/Utils";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/chargers/Tariffs.scss";
import no_tariffs from "../../styles/images/no_tariffs.svg";
import pencil from "../../styles/images/pencil.svg";
import trashcan from "../../styles/images/trashcan.svg";

class Tariffs extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      search: "",
      tariffs: [],
      selectedTariff: null,

      modals: {
        add: false,
        edit: false,
        delete: false,
      },
    };

    this.fetchTariffs = this.fetchTariffs.bind(this);
    this.handleOnAddNewTariff = this.handleOnAddNewTariff.bind(this);
    this.handleOnEditTariff = this.handleOnEditTariff.bind(this);
    this.handleOnConfirm = this.handleOnConfirm.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchTariffs();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchTariffs() {
    axios
      .get("/api/private/salesTariff", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState({ loading: false, tariffs: res.data });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnAddNewTariff(form) {
    const elements = form.elements;
    const name = elements.tariffName.value;
    const tariffType = elements.tariffType.value;
    const tariffChargeBilling = elements.tariffChargeBilling.value;
    const {
      tariffActivationFee,
      tariffBooking,
      tariffCharging,
      tariffParkingDuringCharging,
    } = elements;
    const tariff = {
      activationFee: tariffActivationFee.value,
      bookingAmount: { uom: "", value: tariffBooking.value },
      chargingAmount: {
        uom: tariffType === "Energy Based" ? "kwh" : "min",
        value: tariffCharging.value,
      },
      parkingDuringChargingAmount: {
        uom: "min",
        value: tariffParkingDuringCharging.value,
      },
      parkingAmount: { uom: "min", value: 0 },
      evioCommission: this.props.accountData.evioCommission,
    };

    const post = { name, tariffType, tariff, billingType: tariffChargeBilling };
    axios
      .post("/api/private/salesTariff", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("tariffs_addSuccess"), "primary");
          this.fetchTariffs();
          this.setModal("add", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnEditTariff(form) {
    const elements = form.elements;
    const name = elements.tariffName.value;
    const tariffType = elements.tariffType.value;
    const tariffChargeBilling = elements.tariffChargeBilling.value;
    const {
      tariffActivationFee,
      tariffBooking,
      tariffCharging,
      tariffParkingDuringCharging,
    } = elements;
    const tariff = {
      activationFee: tariffActivationFee.value,
      bookingAmount: { uom: "", value: tariffBooking.value },
      chargingAmount: {
        uom: tariffType === "Energy Based" ? "kwh" : "min",
        value: tariffCharging.value,
      },
      parkingDuringChargingAmount: {
        uom: "min",
        value: tariffParkingDuringCharging.value,
      },
      parkingAmount: { uom: "min", value: 0 },
      evioCommission: this.props.accountData.evioCommission,
    };

    const patch = {
      _id: this.state.selectedTariff._id,
      name,
      tariffType,
      tariff,
      billingType: tariffChargeBilling,
    };
    axios
      .patch("/api/private/salesTariff", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("tariffs_editSuccess"), "primary");
          this.fetchTariffs();
          this.setModal("edit", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnConfirm() {
    axios
      .delete("/api/private/salesTariff", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
        data: {
          _id: this.state.selectedTariff._id,
        },
      })
      .then((res) => {
        if (res.status === 200)
          this.safeSetState({ selectedTariff: null }, () => {
            this.props.setAlert(I18n.t("tariffs_deleteSuccess"), "primary");
            this.fetchTariffs();
            this.setModal("delete", false);
          });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    let { tariffs, selectedTariff, loading, modals, search } = this.state;
    return !loading ? (
      <div id="tariffs" className="main-container">
        <div className="control-bar">
          <ControlRow
            showSearch={tariffs.length > 0}
            search={search}
            onSearchChange={(e) => searchModule.setSearch(this, e.target.value)}
            buttons={[
              {
                label: "tariffs_addTariff",
                onClick: () => this.setModal("add", true),
                disabled:
                  loading ||
                  (tariffs.length >= this.props.userPackage?.tariffsLimit &&
                    this.props.isAdmin === false),
              },
            ]}
          />
        </div>
        {tariffs.length === 0 && (
          <div className="no-tariffs">
            <img src={no_tariffs} alt="" />
            <p>
              <Translate value="tariffs_noTariffsText" />
            </p>
          </div>
        )}
        {tariffs.length > 0 && (
          <div className="component-container">
            <div className="table-container">
              <div className="table-header">
                <div className="row no-gutters">
                  <div className="col-12 row no-gutters titles">
                    <div className="col title">
                      <Translate value="tariffs_name" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_type" />
                    </div>
                    <div className="col-2 title">
                      <Translate value="addTariff_chargeBilling" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_activationFee" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_booking" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_charging" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_parkingDuringCharging" />
                    </div>
                    <div className="col title">
                      <Translate value="tariffs_parking" />
                    </div>
                    <div className="col-1 center title">
                      {/* blank col for icon buttons */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-values">
                {tariffs
                  .filter((i) => searchModule.filter(this, i))
                  .map((t) => {
                    const { billingType, tariffType, tariff, name, _id } = t;
                    // every object of tariff has a value and uom i stopped the splitting here to avoid replicating code
                    const {
                      bookingAmount,
                      chargingAmount,
                      parkingDuringChargingAmount,
                      parkingAmount,
                      activationFee,
                    } = tariff;
                    const { currency } = this.props.preferences;

                    return (
                      <div key={_id} className="row no-gutters">
                        <div className="col-12 row no-gutters values slim">
                          <div className="col">{name}</div>
                          <div className="col">
                            <Translate
                              value={
                                "tariffs_" +
                                _.camelCase(tariffType.replace(" ", ""))
                              }
                            />
                          </div>
                          <div className="col-2">
                            {billingType ? (
                              <Translate value={"addTariff_" + billingType} />
                            ) : (
                              "-"
                            )}
                          </div>
                          <div className="col">
                            {`${activationFee}€` || "-"}
                          </div>
                          <div className="col">
                            {(bookingAmount.value !== null &&
                            bookingAmount.value !== undefined
                              ? bookingAmount.value + currency
                              : "-") +
                              (bookingAmount.uom
                                ? " / " + bookingAmount.uom
                                : "")}
                          </div>
                          <div className="col">
                            {`${chargingAmount.value + currency} / ${
                              chargingAmount.uom
                            }`}
                          </div>
                          <div className="col">
                            {`${
                              parkingDuringChargingAmount.value + currency
                            } / ${parkingDuringChargingAmount.uom}`}
                          </div>
                          <div className="col">
                            {`${0 + currency} / ${parkingAmount.uom}`}
                          </div>
                          <div className="col-1 center">
                            <div className="buttons-container">
                              <button
                                type="button"
                                className="clear"
                                onClick={() =>
                                  this.safeSetState({ selectedTariff: t }, () =>
                                    this.setModal("edit", true)
                                  )
                                }
                              >
                                <img src={pencil} alt="" />
                              </button>
                              <button
                                type="button"
                                className="clear"
                                onClick={() =>
                                  this.safeSetState({ selectedTariff: t }, () =>
                                    this.setModal("delete", true)
                                  )
                                }
                              >
                                <img src={trashcan} alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}

        <TariffModal
          mode="add"
          show={modals.add}
          onHide={() => {
            this.safeSetState({ selectedTariff: null });
            this.setModal("add", false);
          }}
          onSubmit={this.handleOnAddNewTariff}
        />

        <TariffModal
          mode="edit"
          selectedTariff={selectedTariff}
          show={modals.edit}
          onHide={() => {
            this.safeSetState({ selectedTariff: null });
            this.setModal("edit", false);
          }}
          onSubmit={this.handleOnEditTariff}
        />

        <ConfirmationModal
          show={modals.delete}
          onHide={() => this.setModal("delete", false)}
          title="tariffs_deleteTariff"
          body="tariffs_deleteTariffText"
          button="tariffs_deleteTariff"
          onConfirm={this.handleOnConfirm}
        />
      </div>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  preferences: state.account.preferences,
  accountData: state.account.accountData,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(Tariffs);
